import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const ProfileName = () => {
    const { name } = useCurrentAccount();
    return <p className="text-left text-sm font-medium">{name}</p>;
};

export { ProfileName };
